import { isValidUrl } from 'helpers'

export async function addContextToFormData(formData, context) {
  let index = 0
  for (let i = 0; i < context.length; i++) {
    const item = context[i]
    if (item.invalid) continue

    if (item.type === 'image' && isValidUrl(item.content)) {
      const res = await fetch(item.content)
      const blob = await res.blob()
      formData.append(`image`, blob)
      continue
    }

    for (let key in item) {
      if (key === 'invalid') continue
      if (item.hasOwnProperty(key)) {
        if (item[key] instanceof File) formData.append(item.id, item[key])
        else formData.append(`context[${index}][${key}]`, item[key])
      }
    }

    index += 1
  }

  return formData
}
